import { apiFetch } from '@/api/client'

/**
 * Endpoint functions for a Laravel resource nested under a workspace:
 * `/workspaces/{workspaceId}/{path}`. Every function resolves the parsed
 * `{ message, data }` body. FormData payloads are sent as multipart automatically.
 */
export function createWorkspaceResourceApi(path) {
  const base = (workspaceId) => `workspaces/${workspaceId}/${path}`

  return {
    path: base,
    /** @param {number | string} workspaceId @param {object} [params] */
    list: (workspaceId, params = {}, { signal } = {}) =>
      apiFetch(base(workspaceId), { params, signal }),
    /** @param {number | string} workspaceId @param {number | string} id */
    get: (workspaceId, id, { signal } = {}) => apiFetch(`${base(workspaceId)}/${id}`, { signal }),
    /** @param {number | string} workspaceId @param {any} payload */
    create: (workspaceId, payload) =>
      apiFetch(base(workspaceId), { method: 'POST', body: payload }),
    /** @param {number | string} workspaceId @param {number | string} id @param {any} payload */
    update: (workspaceId, id, payload) =>
      apiFetch(`${base(workspaceId)}/${id}`, { method: 'PUT', body: payload }),
    /** @param {number | string} workspaceId @param {number | string} id */
    remove: (workspaceId, id) => apiFetch(`${base(workspaceId)}/${id}`, { method: 'DELETE' }),
    /**
     * Non-CRUD sub-route, e.g. `action(ws, 5, 'complete', payload)` → POST `.../5/complete`.
     * @param {number | string} workspaceId @param {number | string} id @param {string} name
     * @param {any} [payload]
     */
    action: (workspaceId, id, name, payload) =>
      apiFetch(`${base(workspaceId)}/${id}/${name}`, { method: 'POST', body: payload }),
  }
}
